var fxView = /** @class */ (function () {
    function fxView() {
    }
    fxView.STORE_MODULE_NAME = 'fxView';
    return fxView;
}());
export { fxView };



//////////////////
// WEBPACK FOOTER
// ./src/plugins/fxView/lib/fxView.cls.ts
// module id = null
// module chunks = 